import { render } from "./BookingPanel.vue?vue&type=template&id=a8974f2e&scoped=true"
import script from "./BookingPanel.vue?vue&type=script&lang=js"
export * from "./BookingPanel.vue?vue&type=script&lang=js"

import "./BookingPanel.vue?vue&type=style&index=0&id=a8974f2e&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8974f2e"]])

export default __exports__